import {propertyTypes} from "@/services/properties";

const properties = {
  prodottoProperty: {
    code: "1",
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tariffeProperty: {
    code: "2a",
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatoProperty: {
    code: "2b",
    name: "Codice prodotti collegato",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: "3",
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: "4",
    name: "Mercato",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: "5",
    name: "Canale",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: "6",
    name: "Distributori",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: "7",
    name: "Prodotto in commercio",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: "8",
    name: "Inizio commercializzazione",
    description: "",
    order: 9,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: "9",
    name: "Fine commercializzazione",
    description: "",
    order: 10,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: "10",
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 11,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoAssicurazioneProperty: {
    code: "11",
    name: "Tipologia di assicurazione",
    description: "",
    order: 12,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  descProdottoProperty: {
    code: "12",
    name: "Descrizione prodotto",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoProdottoProperty: {
    code: "13",
    name: "Tipologia prodotto",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  garanzieProperty: {
    code: "14",
    name: "Garanzie principali",
    description: "",
    order: 15,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoPrestazioneProperty: {
    code: "15",
    name: "Tipologia di prestazione",
    description: "",
    order: 16,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoCapitaleProperty: {
    code: "16",
    name: "Tipologia di capitale",
    description: "",
    order: 17,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  capitaleAssicurabileProperty: {
    code: "17",
    name: "Capitale assicurabile",
    description: "",
    order: 18,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoRenditaProperty: {
    code: "18",
    name: "Tipologia di rendita",
    description: "",
    order: 19,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  renditaAssicurabileProperty: {
    code: "19",
    name: "Rendita assicurabile",
    description: "",
    order: 20,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  garanzieComplProperty: {
    code: "21",
    name: "Garanzie complementari",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoPremioProperty: {
    code: "22",
    name: "Tipologia premio",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  premioMinimoProperty: {
    code: "23",
    name: "Premio minimo",
    description: "",
    order: 24,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  frazPremioProperty: {
    code: "24",
    name: "Frazionamento del premio",
    description: "",
    order: 25,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataContrattoProperty: {
    code: "26",
    name: "Durata contrattuale",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataPianoPagamentiProperty: {
    code: "27",
    name: "Durata piano pagamento premi",
    description: "",
    order: 28,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxSottoscrizioneProperty: {
    code: "28",
    name: "Età massima alla sottoscrizione",
    description: "",
    order: 29,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxScadenzaProperty: {
    code: "29",
    name: "Età massima alla scadenza",
    description: "",
    order: 30,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  visitaMedicaProperty: {
    code: "30",
    name: "Visita medica",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  carenzaProperty: {
    code: "31",
    name: "Carenza",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  targetMarketProperty: {
    code: "32",
    name: "Target Market",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  decessoQualsiasiProperty: {
    code: "33",
    name: "Decesso (qualsiasi causa)",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoInfortunioProperty: {
    code: "34",
    name: "Decesso per infortunio",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoIncidenteProperty: {
    code: "35",
    name: "Decesso per incidente stradale",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoMalattiaProperty: {
    code: "36",
    name: "Decesso per malattia",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoNucleoProperty: {
    code: "37",
    name: "Decesso nucleo familiare",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  nonAutosufficienzaProperty: {
    code: "38",
    name: "Non autosufficienza",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  malattieProperty: {
    code: "39",
    name: "Malattie gravi",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invInaProperty: {
    code: "40",
    name: "Invalidità/Inabilità",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  terminalProperty: {
    code: "41",
    name: "Terminal illness",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  altreGaranzieProperty: {
    code: "42",
    name: "Altre garanzie assicurative",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  altreOpzioniProperty: {
    code: "54",
    name: "Opzioni contrattuali",
    description: "",
    order: 56,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Flessibilità",
    sectionIndex: 4
  },
  sospensionePremiProperty: {
    code: "55",
    name: "Sospensione dei premi",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Flessibilità",
    sectionIndex: 5
  },
  riattivazionePremiProperty: {
    code: "56",
    name: "Riattivazione dei premi",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Flessibilità",
    sectionIndex: 5
  },
  riduzionePrestProperty: {
    code: "57",
    name: "Riduzione delle prestazioni",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Flessibilità",
    sectionIndex: 5
  },
  applSpeseEmissioneProperty: {
    code: "58",
    name: "Applicazione spese di emissione",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  speseEmissioneProperty: {
    code: "59",
    name: "Spese di emissione",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 6
  },
  applCaricamentoPremioProperty: {
    code: "60",
    name: "Applicazione Caricamento (% del premio)",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  caricamentoPremioProperty: {
    code: "61",
    name: "Caricamento (% del premio)",
    description: "",
    order: 63,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 6
  },
  applCaricamentoCapitaleProperty: {
    code: "62",
    name: "Applicazione Caricamento (% del capitale assicurato)",
    description: "",
    order: 64,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  caricamentoCapitaleProperty: {
    code: "63",
    name: "Caricamento (% del capitale assicurato)",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 6
  },
  applCaricamentoEuroProperty: {
    code: "64",
    name: "Applicazione Caricamento (€)",
    description: "",
    order: 66,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  caricamentoEuroProperty: {
    code: "65",
    name: "Caricamento (€)",
    description: "",
    order: 67,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 6
  },
  interessiFrazProperty: {
    code: "67",
    name: "Interessi di frazionamento",
    description: "",
    order: 69,
    value: "",
    values: [],
    valueDescription: "",
    frazionamento: {
      mensile: "", mensileSign: "",
      bimestrale: "", bimestraleSign: "",
      trimestrale: "", trimestraleSign: "",
      quadrimestrale: "", quadrimestraleSign: "",
      semestrale: "", semestraleSign: "",
    },
    type: propertyTypes.FRAZIONAMENTO,
    sectionName: "Costi",
    sectionIndex: 6
  },
  costoVisitaMedicaProperty: {
    code: "68",
    name: "Costo visita medica",
    description: "",
    order: 70,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  altriCostiProperty: {
    code: "69",
    name: "Altri costi",
    description: "",
    order: 71,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  presenzaCashbackProperty: {
    code: "70",
    name: "Presenza Cashback",
    description: "",
    order: 72,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 6
  },
  cashbackProperty: {
    code: "71",
    name: "Cashback",
    description: "",
    order: 73,
    value: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Costi",
    sectionIndex: 6
  },
  tipoRetrDistrProperty: {
    code: "72",
    name: "Tipologia retrocessione alla distribuzione",
    description: "",
    order: 74,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 7
  },
  retrDistrProperty: {
    code: "73",
    name: "Retrocessione alla distribuzione",
    description: "",
    order: 74,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    stringList: [{ value: "", valueSign: "", valueLabel: "" }],
    type: propertyTypes.STRING_LIST,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 7
  },
  noteProperty: {
    code: "74",
    name: "Note",
    description: "",
    order: 75,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 8
  },
};

export default properties;
